import Vue from 'vue'
import VueAWN from 'vue-awesome-notifications'
import VueI18n from 'vue-i18n'

import App from './Examiner.vue'
import store from './store/store.examiner'
import router from './router/router.examiner'
import translations from './translations'
import { locale, awnOptions, setServerLanguage } from './config'
import { loading } from '@/plugins/loading'
import BaseInput from '@/components/BaseInput'
import { initSentry } from '@/utils/utils.sentry'

const Loading = loading(store)

Vue.component(BaseInput.name, BaseInput)
Vue.use(Loading)
Vue.use(VueAWN, awnOptions)
Vue.use(VueI18n)
Vue.config.productionTip = false

initSentry(Vue, router)

new Vue({
  i18n: translations(locale),
  router,
  store,
  beforeCreate () {
    setServerLanguage()
  },
  render: h => h(App)
}).$mount('#app')
